const revenueRecognitionMethods = {
  invoiced: { id: 'invoiced', name: 'As Invoiced' },
  manual: { id: 'manual', name: 'Manual' },
  automated_hours: { id: 'automated_hours', name: 'Automated - Percentage of Billable Hours' },
  automated_services_cost: { id: 'automated_services_cost', name: 'Automated - Percentage of Services Cost' },
  automated_tm_basis: { id: 'automated_tm_basis', name: 'Automated - Percentage of Time & Materials Revenue' },
};

export default revenueRecognitionMethods;
